export const XCOVER_PARTNER_ID = 'S6QVK';
export const SHOPEE_PARTNER_ID = '3AZ60';
export const TILE_PARTNER_ID = '1H6C5';
export const FUNRAISIN_PARTNER_ID = '3014D';
export const PETPAL_PARTNER_ID = '0QRA8';
export const SKYSCANNER_PARTNER_ID = 'YE4IA';
export const AMAZON_PARTNER_ID = 'OBWZH';
export const AWS_CYBER_PROTECTION_PARTNER_ID = 'W4HO6';
export const KW_PREMIUM_HOME_WARRANTY_PARTNER_ID = 'C8IXH';
export const SHIPRUSH_PARTNER_ID = 'N1428';
export const ETRAVELI_PARTNER_ID = 'VEYWS';
export const RMS_PARTNER_ID = 'T69U3';
export const REVOLUT_PARTNER_ID = 'GX9AF';
export const STAGING_REVOLUT_PARTNER_ID = 'UASL5';
export const PRICELINE_PARTNER_ID = '0WAGA';
export const RYANAIR_PARTNER_ID = '71RKO';
export const VUELING_PARTNER_ID = 'TQLES';
export const SAS_PARTNER_ID = 'PJOE3';
export const EBAY_PARTNER_ID = 'ZNJ0A';
export const OMIO_PARTNER_ID = 'GFGL0';
export const HOME_TO_GO_PARTNER_ID = 'Q7YSW';
export const MAKE_MY_TRIP_PARTNER_ID = 'T5ZAE';
export const TOUR_RADAR_PARTNER_ID = 'PKQ3G';
export const UBER_COMMERCIAL_MOTOR_PARTNER_ID = 'UE1U3';
export const HOLISTO_PARTNER_ID = 'S37OE';
export const NORSE_ATLANTIC_AIRWAYS_PARTNER_ID = '09GX9';
export const AIRBALTIC_PARTNER_ID = 'O2PKF';

export const ANNUAL_POLICY_PARTNER_IDS = [ETRAVELI_PARTNER_ID];

// Avoid to use this constant if possible,
// Use partner id constant instead for accuracy.
// eg: EBAY_PARTNER_ID
export const PARTNER_SLUG = {
  skyscanner: 'skyscanner',
};

export const INCLUSIONS_AND_EXCLUSIONS_PAGES_MAP = {
  [VUELING_PARTNER_ID]: 'claim-test-vueling',
  [SAS_PARTNER_ID]: 'claim-test-sas',
};
export const EXPEDIA_PARTNER_ID = '0IX1G';
export const STEADFAST_LIFE_PARTNER_ID = 'OIGNR';
export const TIKTOK_PARTNER_ID = 'KZFPO';
export const KLARNA_PLUS_PARTNER_ID = 'SBR8U';
export const AGODA_PARTNER_ID = 'PHNH9';
export const USA_GATEWAY_PARTNER_ID = 'QZX27';
export const USA_GATEWAY_STANDALONE_PARTNER_ID = '8BWGO';
export const USA_GATEWAY_PARTNER_IDS = [USA_GATEWAY_PARTNER_ID, USA_GATEWAY_STANDALONE_PARTNER_ID];
export const GOSEE_STANDALONE_PARTNER_ID = '9V2C1';

export const SKIP_MODIFY_PROTECTION_MODAL_PARTNER_IDS = [GOSEE_STANDALONE_PARTNER_ID];
